import React, { useEffect, useState } from 'react';
import AnimatedContent from "../Common/AnimatedContent";
import { FaRupeeSign } from "react-icons/fa";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import Loadericon from "../Common/Loadericon"

const OngoingProperties = () => {
  const navigate = useNavigate();
  const [propertyproperty, setPropertyproperty] = useState([{}]);
  const [isLoading, setIsLoading] = useState(true);
  const [error] = useState(null);
  const title_text = "Our Properties";
  const title_characters = title_text.split("");
  const textVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
    }),
  };
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const handleClick = (property_id) => {
    window.scrollTo(0, 0);
    navigate(`/property-details/${property_id}`);
  };

  useEffect(() => {
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_GET_PROPERTIES_LIST_HOME}?is_homepage=true`)
          .then((response) => response.json())
      .then((property) => {
        if (Array.isArray(property)) {
          setPropertyproperty(property);
          setIsLoading(false);
        } else {
          console.error("Expected an array but got:", property);
          setPropertyproperty([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching property property:", error);
        setPropertyproperty([]);
      });
  }, []);

  if (isLoading) {
    return <div className="section-featured tf-spacing-1 p-2"><Loadericon /></div>;
  }

  if (error) {
    return (
      <div className="section-featured tf-spacing-1 p-2">
        <div className="alert alert-danger">Error loading property property: {error}</div>
      </div>
    );
  }

  return (
    <div className="main-content">
      <section className="section-property-layout">
        <div className="tf-container">
          <div className="row">
            <div className="col-12">
              <div className="heading-section mb-48 text-center">
                <div ref={ref} className="heading-section " style={{ whiteSpace: "nowrap" }}>
                  <h2 className="title balance">
                    {title_characters.map((char, i) => (
                      <motion.span
                        key={i}
                        className="inline-block"
                        variants={textVariants}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        custom={i}
                      >
                        {char}
                      </motion.span>
                    ))}
                  </h2>
                </div>
                <AnimatedContent
                  distance={5}
                  direction="vertical"
                  reverse={false}
                  config={{ tension: 80, friction: 20 }}
                  initialOpacity={0.2}
                  animateOpacity
                  scale={1.1}
                  threshold={0.2}
                >
                  <p className="text-1 animate__fadeInUp animate__animated">
                    CoOwnSpace makes real estate investing affordable, passive, and hassle-free. Own, earn, and grow!
                  </p>
                </AnimatedContent>
              </div>

              <div className="tab-content">
                <div id="listLayout" className="tab-pane active">
                  <div className="tab-paneactive show" id="listLayout-sub" role="tabpanel">
                    <div className="tf-grid-layout lg-col-2">
                      {propertyproperty.map((property) => (
                        <div key={property.property_id} className="box-house style-list hover-img">
                          <div className="image-wrap">
                            {Array.isArray(property.property_images) && property.property_images.length > 0 && (
                              <img
                                className="lazyload img01"
                                loading="lazy"
                                src={property.property_images[0].src}
                                alt={property.property_images[0].title}
                              />
                            )}
                          </div>
                          <div className="content">
                            <h3 className="title h5">
                              {property.property_name}
                            </h3>
                            <p className="location text-1 line-clamp-1">
                              <i className="icon-location"></i> {property?.property_address}
                            </p>
                            <ul className="meta-list flex cos-custom">
                              <li className="meta-item">
                                <div className="text-9 flex">{property?.property_details[0].label}</div>
                                <div className="text-9 flex"><span>{property?.property_details[0].value}</span></div>
                              </li>
                              <li className="meta-item">
                              <div className="text-9 flex">{property?.property_details[2].label}</div>
                              <div className="text-9 flex"><span>{property?.property_details[2].value}</span></div>
                              </li>
                            </ul>
                            <div className="bot flex justify-between items-center">
                              <h4 className="price">
                                COS Value:<span><FaRupeeSign /></span>{property?.fraction_details[4].value}
                              </h4>
                              <div className="wrap-btn flex">
                                <button className="tf-btn style-border pd-4" onClick={() => handleClick(property.property_id)}>Details</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OngoingProperties;



// import React, { useRef, useEffect, useState } from 'react';
// import boxhouse from '../../Assests/images/section/box-house.jpg';  
// import SplitText from "../Common/SplitText";
// import AnimatedContent from '../Common/AnimatedContent';

// const Propertycards = () => {
//     const [properties, setProperties] = useState([]);
//     const ourproperties = useRef(null);

//     useEffect(() => {
       
//         const fetchedProperties = [
//             {
//                 "property_id": 1,
//                 "property_name": "Red Sandal Farm Land",
//                 "property_images": {
//                     "0": "url1",
//                     "1": "url2"
//                 },
//                 "basic_details": {
//                     "property_area": "40 acre",
//                     "property_address": "Medavakkam, Chennai - 600100",
//                     "property_type": "FARM LAND",
//                     "availability_status": "Available",
//                     "boundary_wall": "Yes",
//                     "no_of_units": "100+ Plots",
//                     "min_lockin_period": "20 Years",
//                     "open_side_count": "1",
//                     "total_cos_fraction": "15",
//                     "available_cos_fraction": "15",
//                     "cos_fraction_price": "4,00,000",
//                     "total_property_price": "42,00,000"
//                 },
//                 "amenities": [
//                     "Water Supply", "Electricity", "Security Guard", "Internal Road", 
//                     "Garden", "CCTV", "Main Entrance Arch", "Managed Farm", "Borewell", 
//                     "Avenue Plantations", "Car Parking", "Fruit Plantation", "Drip Irrigation"
//                 ],
//                 "investment_benefits": {
//                     "Reduce risk": "By diversifying your investments into a portfolio of real estate assets",
//                     "Convenience": "Easy to buy & sell, After min lock-in period",
//                     "Hassle Free": "Professional Property Management Services by Master Property Manager (MPM)",
//                     "Long Term Profits": "Long term capital appreciation & rental yield"
//                 },
//                 "what_nearby": {
//                     "School": "0.7 km",
//                     "University": ".3 km"
//                 }
//             }
//             // Add more property objects as needed...
//         ];

//         // Set the fetched properties in state
//         setProperties(fetchedProperties);
        
//         // Smooth scroll to section if hash matches
//         if (window.location.hash === '#ourproperties') {
//             ourproperties.current?.scrollIntoView({ behavior: 'smooth' });
//         }
//     }, []);

//     return (
//         <section ref={ourproperties} id='ourproperties' className="section-listing tf-spacing-1">
//             <div className="tf-container">
//                 <div className="row">
//                     <div className="col-12">
//                         <div className="heading-section text-center ">
//                             <SplitText
//                                 text="Our Properties"
//                                 className=" title text-anime-wave"
//                                 delay={30}
//                                 animationFrom={{ opacity: 0, transform: 'translate3d(0,50px,0)' }}
//                                 animationTo={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
//                                 easing="easeOutCubic"
//                                 threshold={0.2}
//                                 rootMargin="-50px"
//                             />
//                             <AnimatedContent
//                                 distance={5}
//                                 direction="vertical"
//                                 reverse={false}
//                                 config={{ tension: 80, friction: 20 }}
//                                 initialOpacity={0.2}
//                                 animateOpacity
//                                 scale={1.1}
//                                 threshold={0.2}
//                             >
//                             </AnimatedContent>
//                         </div>

//                         <div className="swiper style-pagination tf-sw-mobile-1" data-screen="767" data-preview="1" data-space="15">
//                             <div className="swiper-wrappers tf-layout-mobile-md md-col-2  lg-col-3">
//                                 {properties.map((property) => (
//                                     <div key={property.property_id} className="swiper-slide">
//                                         <div className="box-house hover-img">
//                                             <div className="image-wrap">
//                                                 <a href="/property-details">
//                                                     <img className="lazyload" data-src={property.property_images[0] || boxhouse} src={property.property_images[0] || boxhouse} alt="" />
//                                                 </a>
//                                                 <ul className="box-tag flex gap-8">
//                                                     <li className="flat-tag text-4 bg-main fw-6 text-white">Featured</li>
//                                                     <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                 </ul>
//                                                 <div className="list-btn flex gap-8">
//                                                     <a href="#" className="btn-icon save hover-tooltip">
//                                                         <i className="icon-save"></i>
//                                                         <span className="tooltip">Add Favorite</span>
//                                                     </a>
//                                                     <a href="#" className="btn-icon find hover-tooltip">
//                                                         <i className="icon-find-plus"></i>
//                                                         <span className="tooltip">Quick View</span>
//                                                     </a>
//                                                 </div>
//                                             </div>

//                                             <div className="content">
//                                                 <h5 className="title">
//                                                     <a href="/property-details">{property.property_name}</a>
//                                                 </h5>
//                                                 <p className="location text-1 line-clamp-1">
//                                                     <i className="icon-location"></i> {property.basic_details.property_address}
//                                                 </p>
//                                                 <ul className="meta-list flex cos-custom">
//                                                     <li className="meta-item">
//                                                         <div className="text-9 flex">Property Type</div>
//                                                         <div className="text-9 flex"><span>{property.basic_details.property_type}</span></div>
//                                                     </li>
//                                                     <li className="meta-item">
//                                                         <div className="text-9 flex">Property Size</div>
//                                                         <div className="text-9 flex"><span>{property.basic_details.property_area}</span></div>
//                                                     </li>
//                                                 </ul>

//                                                 <div className="bot flex justify-between items-center">
//                                                     <h5 className="price">
//                                                         COS Value: INR {property.basic_details.cos_fraction_price}
//                                                     </h5>
//                                                     <div className="wrap-btn flex">
//                                                         <a href="/property-details" className="tf-btn style-border pd-4">Details</a>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                             <div className="sw-pagination sw-pagination-mb-1 text-center d-lg-none d-block"></div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Propertycards;
